'use client';

import GrumftIabAd from '../Ads/grumft-iab-ad';
import MediaGWidget from '../Ads/media-g-widget';
import IdealMediaWidget from '../Ads/ideal-media-widget';
import PostMidContentAds from '../Ads/post-mid-content-ads';
import { GRUMFT_IAB_PRESETS } from '../../../lib/grumft-iab-presets';

export function renderArticleParagraphSlot(slotType, slotProps = {}) {
  switch (slotType) {
    case 'PostMidContentAds':
      return <PostMidContentAds />;
    case 'GrumftIabAd':
    case 'GrumftIab336CategoryAd': {
      const presetKey =
        typeof slotProps.preset === 'string' && slotProps.preset.trim()
          ? slotProps.preset.trim()
          : 'zone336x280_7';
      const base =
        GRUMFT_IAB_PRESETS[presetKey] || GRUMFT_IAB_PRESETS.zone336x280_7;
      return (
        <GrumftIabAd
          containerId={base.containerId}
          grumftZone={base.grumftZone}
          slotHeightPx={
            typeof base.slotHeightPx === 'number' ? base.slotHeightPx : 300
          }
          className={
            typeof slotProps.className === 'string' ? slotProps.className : ''
          }
          visualVariant={
            slotProps.visualVariant === 'post' ? 'post' : 'default'
          }
          showLabel={
            slotProps.showLabel === undefined
              ? true
              : Boolean(slotProps.showLabel)
          }
        />
      );
    }
    case 'MediaGWidget': {
      const wid = slotProps.widgetId;
      if (wid == null || String(wid).trim() === '') return null;
      return (
        <MediaGWidget
          widgetId={String(wid)}
          className={
            typeof slotProps.className === 'string' ? slotProps.className : ''
          }
          slotHeightPx={slotProps.slotHeightPx}
          minHeightPx={
            typeof slotProps.minHeightPx === 'string'
              ? slotProps.minHeightPx
              : undefined
          }
          maxHeightPx={
            typeof slotProps.maxHeightPx === 'number'
              ? slotProps.maxHeightPx
              : undefined
          }
          overflowAuto={Boolean(slotProps.overflowAuto)}
          visualVariant={
            slotProps.visualVariant === 'post' ? 'post' : 'default'
          }
          postVariantNoBackground={Boolean(slotProps.postVariantNoBackground)}
          showLabel={
            slotProps.showLabel === undefined
              ? true
              : Boolean(slotProps.showLabel)
          }
        />
      );
    }
    case 'IdealMediaWidget': {
      const idealWid = slotProps.widgetId;
      if (idealWid == null || String(idealWid).trim() === '') return null;
      return (
        <IdealMediaWidget
          widgetId={String(idealWid)}
          className={
            typeof slotProps.className === 'string' ? slotProps.className : ''
          }
          slotHeightPx={slotProps.slotHeightPx}
          minHeightPx={
            typeof slotProps.minHeightPx === 'string'
              ? slotProps.minHeightPx
              : undefined
          }
          maxHeightPx={
            typeof slotProps.maxHeightPx === 'number'
              ? slotProps.maxHeightPx
              : undefined
          }
          overflowAuto={Boolean(slotProps.overflowAuto)}
          visualVariant={
            slotProps.visualVariant === 'post' ? 'post' : 'default'
          }
          postVariantNoBackground={Boolean(slotProps.postVariantNoBackground)}
          showLabel={
            slotProps.showLabel === undefined
              ? true
              : Boolean(slotProps.showLabel)
          }
        />
      );
    }
    default:
      return null;
  }
}
